import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { from, iif, of } from 'rxjs';
import { catchError, concatMap, map, switchMap, tap } from 'rxjs/operators';

import { AZURE_CA_URLS } from '../../shared/enums/HttpStatusCodes';
import { IMPULSA_GEPP_ENDPOINTS, NativeStorageNamesV2 } from '../../shared/models/Constants';
import { IEnko, IResultEnko } from '../../shared/models/Enko.model';
import { SharedServiceService } from '../../shared/services/shared-service.service';
import {
    errorEnko,
    errorUpdatePhoneEnko,
    getEnko,
    successEnko,
    successUpdatePhoneEnko,
    updatePhoneEnko,
} from '../actions/enko.actions';
import { StorageData } from './../../shared/services/utilities/storage-data.class';

@Injectable()
export class EnkoEffets {

    private RegistroImpulsaGepp = NativeStorageNamesV2.SesionRegistroImpulsaGepp;
    private lastToken = '';

    constructor(
        private actions$: Actions
        , private httpS: SharedServiceService
    ) { }

    /**
     * * Baja los datos actualizados del usuario
     */
    public getEnko$ = createEffect(
        () => this.actions$.pipe(
            ofType(getEnko),
            switchMap(() => from(StorageData.getDataStorage(this.RegistroImpulsaGepp))),
            map(storage => {
                this.lastToken = storage && storage.token ? storage.token : '';
                return this.lastToken;
            }),
            concatMap((token: string) => this.httpS.executeRequestByUser(IMPULSA_GEPP_ENDPOINTS.post_sesion_registro, { token }, this.httpS.getAzureCAUrl(AZURE_CA_URLS.INTEGRACIONES))),
            tap(resp => this.saveEnko(resp)),
            map(resp => successEnko(resp)),
            catchError((err: Error) => of(errorEnko({ payload: err }))),
        )
    );

    /**
     * Valida si guarda en el storage del dispositivo los datos de enko
     * @param {IResultEnko} resp Datos de la respuesta de enko, contiene expiration,
     * ese tiene la fecha y hora en que caduca los datos de enko
     */
    private saveEnko = (resp: IResultEnko) => {
        if (resp.data.hasOwnProperty('token') && this.lastToken !== resp.data.token) {
            StorageData.setDataStorage(this.RegistroImpulsaGepp, { ...resp.data });
        }
    }

    /**
     * * Actualiza telefono del tendero cuando realiza el cambio en perfil, para enko
     */
    public updatePhoneEnko$ = createEffect(
        () => this.actions$.pipe(
            ofType(updatePhoneEnko),
            switchMap(actions => from(StorageData.getDataStorage(this.RegistroImpulsaGepp))
                .pipe(
                    map((storage: IEnko) => {
                        const token = storage && storage.token ? storage.token : '';
                        return { token, telefono: actions.telefono, telefonoPrevio: actions.telefonoPrevio };
                    })
                )
            ),
            concatMap(actions => iif(
                () => typeof actions === 'object'
                , this.httpS.executeRequestByUser(IMPULSA_GEPP_ENDPOINTS.post_actualiza_telefono, actions, this.httpS.getAzureCAUrl(AZURE_CA_URLS.INTEGRACIONES))
                , of({ success: true, message: 'With nothing to update', data: {} }))
            ),
            map(resp => successUpdatePhoneEnko(resp)),
            catchError((err: Error) => of(errorUpdatePhoneEnko({ payload: err })))
        )
    );
}
